// Function to check and remove extra widgets
function checkAndRemoveExtraWidgets() {
    const targetNode = document.querySelector('.route-div');
    if (targetNode) {
        const widgets = targetNode.querySelectorAll('route-protect-widget');
        if (widgets.length > 1) {
            widgets.forEach((widget, index) => {
                if (index < widgets.length - 1) {
                  widget.remove();
                }
            });
        }
    }
}

// Function to handle changes in the route-div
function handleDivChanges() {
    const targetNode = document.querySelector('.route-div');
    if (targetNode) {
        targetNode.addEventListener('DOMNodeInserted', checkAndRemoveExtraWidgets);
        targetNode.addEventListener('DOMNodeRemoved', checkAndRemoveExtraWidgets);
    }
}

// Initialize the event listeners on page load
window.addEventListener('DOMContentLoaded', (event) => {
    handleDivChanges();
    checkAndRemoveExtraWidgets(); // Initial check
});